<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <site-query :sites="filterSites" :query="query" />

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <!-- <el-checkbox v-model="query.isMultipleIntegral" size="small" label="重积分" border v-if="query.isAuditCompleted !== false" /> -->

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <unit-switch
          :default-unit-prop.sync="unitProp"
          @change="onUnitPropChange"
        />

        <el-input
          v-model="query.num"
          type="number"
          size="small"
          style="width:230px;margin-left:10px;"
          @keydown.native.enter="onTopNumChanged"
        >
          <template #prepend>显示前</template>
          <template #append>SOA</template>
        </el-input>
      </template>

      <div
        v-for="data in dataList"
        :key="data.id"
        :style="{
          display: 'grid',
          flex: `0 0 ${Math.max(800, ((currentQuery.num | 0) * 25) + 485)}px`,
          'max-height': `${Math.max(800, siteIsoaDataMap[data.id] ? ((siteIsoaDataMap[data.id].isoa.length | 0) * 25) + 485 : 800)}px`
        }"
      >
        <soa-chart-group
          :data-config="data"
          :unit-prop="unitProp"
          :top="query.num"
          :is-audit-completed="query.isAuditCompleted"
          :is-multiple-integral="query.isMultipleIntegral"
          :hour-avg-isoa-data="siteIsoaDataMap[data.id]"
          :style="{
            flex: `0 0 ${Math.max(400, ((currentQuery.num | 0) * 25) + 85)}px`,
            'max-height': `${Math.max(400, siteIsoaDataMap[data.id] ? ((siteIsoaDataMap[data.id].isoa.length | 0) * 25) + 85 : 400)}px`
          }"
        />
        <div style="width: 100%;height: 400px;">
          <s-o-a-stack-chart
            ref="soa-stack-charts"
            :unit="data.unit"
            :site-name="data.siteName"
            :data="data.stackChartData"
            :data-time="data.stackDataTimes"
            :factor-map="factorMap"
            :site-isoa-data-map="siteIsoaDataMap[data.id]"
          />
        </div>
      </div>
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteFactorData from '../../../BaseSiteFactorData'
import DataFormatter from '../../../../model/DataFormatter'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'

import LayoutContent from '../../../../components/Layout/Content'
import DataTimeQuery from '../../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../../components/Data/Query/SiteQuery'
import CompletedQuery from '../../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../../components/Data/DataWrapper'
import UnitSwitch from '../../../../components/Data/UnitSwitch'
import SoaChartGroup from './SoaChartGroup'
import SOAStackChart from '../../../../components/Data/SOAStackChart'

export default {
  name: 'SOAAnalysis',
  routeInfo: {
    label: '气溶胶SOA分析',
    icon: 'fa fa-users'
  },
  extends: BaseSiteFactorData,
  components: {LayoutContent, DataTimeQuery, SiteQuery, CompletedQuery, DataWrapper, UnitSwitch, SoaChartGroup, SOAStackChart},
  data: () => ({
    query: {
      num: 10,
      isFuse: false,
      isGetInvalidData: true,
      isMultipleIntegral: true,
      unit: ''
    },
    chartType: 'line',
    stackType: 0,
    topData: [],
    aaa: [],
    siteIsoaDataMap: null
  }),
  computed: {
    siteDeviceCategoryConfig () {
      return [
        new DeviceCategoryConfig(process.env.VOCS_DEVICE_CATEGORY, true, siteDeviceFactors => {
          let newFactors = []

          if (siteDeviceFactors.length > 0) {
            let ofpFactor = {
              id: 'soa',
              factorId: 'soa',
              name: 'SOA'
            }

            Object.defineProperty(ofpFactor, 'stdUnit', {
              get: this.getUnit(siteDeviceFactors[0]),
              enumerable: true
            })

            Object.defineProperty(ofpFactor, 'displayUnit', {
              get: this.getUnit(siteDeviceFactors[0]),
              enumerable: true
            })

            newFactors.push(ofpFactor)
          }

          return newFactors
        })
      ]
    },
    downloadName: () => 'SOA小时数据',
    isSetUnit: () => true
  },
  methods: {
    // onAuditCompletedChanged () {
    //   let {query} = this
    //   if (query.isAuditCompleted === 'isFuse') {
    //     query.isFuse = true
    //     delete query.isAuditCompleted
    //   } else {
    //     query.isFuse = false
    //   }
    //   if (query.isAuditCompleted === true) {
    //     query.isGetInvalidData = false
    //   } else {
    //     query.isGetInvalidData = true
    //   }
    //   query.isMultipleIntegral = false

    //   this.afterSetSiteIds()
    // },
    getUnit (factor) {
      return () => factor[this.unitProp]
    },
    getSeriesParam (dimension, dimensionIds) {
      return {
        type: 'bar',
        barMaxWidth: 30
      }
    },
    formatData () {
      console.time('format3')

      let {currentQuery} = this

      if (Object.keys(currentQuery).length === 0) {
        return
      }

      let {dimension} = this

      DataFormatter.format.bind(this)(currentQuery, dimension === 0 ? currentQuery.factorIds : currentQuery.siteIds, (data, newData, dimensionIdProp1, ts, dataTime) => {
        let {seriesMap} = newData
        let dimensionIdsLen = dimensionIdProp1.length

        for (let i = 0; i < dimensionIdsLen; i++) {
          let dimensionId = dimensionIdProp1[i]
          let series = seriesMap[dimensionId]

          if (series) {
            let value = data[dimensionId]

            if (Number.isFinite(value)) {
              series.push({
                ts,
                dataTime,
                value,
                isHaveIntegral: data.isHaveIntegral || false,
                flag: data.flag || null
              })
            }
          }
        }
      }, 'tmpList', 'dataList')

      console.timeEnd('format3')
    },
    getData () {
      let query = JSON.parse(JSON.stringify(this.currentQuery))
      query.factorIds = ['soa']
      this.query = this.currentQuery = query
      if (!query.siteIds.length) {
        this.dataList = []
        return
      }

      this.changeLoadStatus(true)
      this.$api.Data.getStatisticAnalysisSOA(query).then(this.setDataList).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    setDataList (dataList) {
      if (!dataList) {
        this.dataList = []
        return
      }
      let {soa, top} = dataList
      this.tmpList = JSON.parse(JSON.stringify(soa))
      let topData = top
      let {filterSiteMap, factorMap, query: {unit}} = this

      if (!soa.length || !top.length) {
        this.dataList = []
        return
      }

      let tempTop
      if (topData.length > 0) {
        let beginTopTs = new Date(topData[0].dataTimeStr).getTime()
        let endTopTs = new Date(topData[topData.length - 1].dataTimeStr).getTime()
        let tsStep = 3600000
        let dataMap = topData.reduce((map, el) => {
          if (!map[el.siteId]) {
            map[el.siteId] = {}
          }

          if (!map[el.siteId][el.factorId]) {
            map[el.siteId][el.factorId] = []
          }
          map[el.siteId][el.factorId].push(el)
          return map
        }, {})
        let aaa = Object.values(dataMap).map(el => {
          let bbb = Object.values(el).map(item => {
            let temp = {}
            for (let ts = beginTopTs; ts <= endTopTs; ts += tsStep) {
              temp[ts] = {
                dataTimeStr: new Date(ts).format('YYYY-MM-DD HH:00:00'),
                factorId: item[0].factorId,
                factorName: item[0].factorName,
                siteId: item[0].siteId,
                soa: ''
              }
            }
            let ccc = item.reduce((map, data) => {
              let dataTs = new Date(data.dataTimeStr).getTime()
              if (!map[dataTs]) {
                map = JSON.parse(JSON.stringify(temp))
              }

              map[dataTs] = data

              return map
            }, {})

            return Object.values(ccc)
          })

          return bbb
        })

        let tempTopMap = aaa.flat(Infinity).reduce((map, el) => {
          if (!map[el.siteId]) {
            map[el.siteId] = {
              id: el.siteId,
              name: filterSiteMap[el.siteId].name,
              data: []
            }
          }
          let tempTopEl = el
          tempTopEl.factorName = factorMap[tempTopEl.factorId].name
          map[el.siteId].data.push(tempTopEl)

          return map
        }, {})

        tempTop = Object.values(tempTopMap).reduce((top, el) => {
          let tempData = el.data
          if (!top[el.id]) {
            top[el.id] = {
              name: el.name,
              dataTimes: [],
              chartData: []
            }
          }

          let seriesData = tempData.reduce((map, item) => {
            if (!map[item.factorId]) {
              map[item.factorId] = {
                name: item.factorName,
                type: 'bar',
                stack: 'total',
                data: []
              }
            }

            top[el.id].dataTimes.push(new Date(item.dataTimeStr).format('YY/MM/DD HH'))
            map[item.factorId].data.push({
              dataTime: new Date(item.dataTimeStr).format('YY/MM/DD HH'),
              isHaveIntegral: item.isHaveIntegral || false,
              unit: unit,
              value: Number(Number(item.isoa).toFixed(3))
            })
            return map
          }, {})

          top[el.id].chartData = Object.values(seriesData)

          return top
        }, {})
      }

      this.formatData()

      this.dataList.forEach(data => {
        if (topData.length > 0) {
          data.stackDataTimes = tempTop[data.id] ? tempTop[data.id].dataTimes : []
          data.stackChartData = tempTop[data.id] ? tempTop[data.id].chartData : []
        } else {
          data.stackDataTimes = []
          data.stackChartData = []
        }
        data.siteName = data.name
        data.unit = unit
        data.name += ' SOA总量时序图'
      })

      this.siteIsoaDataMap = dataList.soa.length > 0 ? Object.freeze(dataList.soa.reduce((map, data) => {
        let {pollutantData} = data

        if (pollutantData) {
          map[data.siteId] = {
            title: data.title,
            isoa: pollutantData
          }
        }

        return map
      }, {})) : null

      setTimeout(() => {
        if (this.getSOAStackCharts().length > 0) {
          this.getSOAStackCharts().forEach(el => {
            el.render()
          })
        }
      }, 100)
    },
    getSOAStackCharts () {
      return this.$refs['soa-stack-charts']
    },
    onUnitPropChange (unitProp) {
      let {filterFactors} = this

      if (filterFactors.length > 0) {
        this.query.unit = filterFactors[0][unitProp]
        this.afterSetSiteIds()
      }
    },
    onTopNumChanged () {
      this.afterSetSiteIds()
    }
  }
}
</script>

<style lang="scss" scoped>
.toolbar .el-checkbox {
  font-size: 17px;
  height: 32px;

  /deep/ .el-checkbox__label {
    line-height: 16px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/06SOAAnalysis/index.vue